import { gql } from '@apollo/client';

export const GET_PROCUREMENT_HIERARCHY = gql(/* GraphQL */ `
    query GetProcurementHierarchy {
        getProcurementHierarchy {
            director {
                id
                firstName
                lastName
                email
                faxNo
                mobileNo {
                    dialingCode
                    countryCode
                    number
                }
                telNo {
                    dialingCode
                    countryCode
                    number
                }
                speedDial
                designation
            }
            executives {
                id
                firstName
                lastName
                email
                faxNo
                mobileNo {
                    dialingCode
                    countryCode
                    number
                }
                telNo {
                    dialingCode
                    countryCode
                    number
                }
                speedDial
                designation
                managers {
                    id
                    firstName
                    lastName
                    email
                    faxNo
                    mobileNo {
                        dialingCode
                        countryCode
                        number
                    }
                    telNo {
                        dialingCode
                        countryCode
                        number
                    }
                    speedDial
                    designation
                    categories {
                        id
                        name
                        benchmarkMargin
                        productCount
                    }
                }
            }
        }
    }
`);
